"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ENERGY_CLASSES = {
    'A+++': 1,
    'A++': 1,
    'A+': 1,
    A: 1,
    B: 1,
    C: 1,
    D: 1,
    E: 1
};
/**
 * Energy Class Parser.
 */
var EnergyClassParser = /** @class */ (function () {
    function EnergyClassParser() {
    }
    /**
     * Parses product and returns energy class.
     *
     * @param product Product item.
     * @returns EnergyClass.
     */
    EnergyClassParser.parseProduct = function (product) {
        var _a, _b;
        if (!((_b = (_a = product.content) === null || _a === void 0 ? void 0 : _a.technicalInformation) === null || _b === void 0 ? void 0 : _b.length)) {
            return null;
        }
        for (var _i = 0, _c = product.content.technicalInformation; _i < _c.length; _i++) {
            var item = _c[_i];
            if (typeof item.valueMetric === 'string') {
                var value = item.valueMetric.split(' ')[0];
                if (ENERGY_CLASSES[value]) {
                    return value;
                }
            }
        }
        return null;
    };
    return EnergyClassParser;
}());
exports.default = EnergyClassParser;
//# sourceMappingURL=EnergyClassParser.js.map